// A GROUP'S TWO BUILT-IN REALMS, and what each one lets a member do. "No access"
// carries a `builtin` marker; "Full Access" is the group's default realm
// (`is_default`), where its admins sit. The server says the same thing as `kind`
// (authz/group_member.py realm_kind). Every other realm — the starter "Members"
// included — says what it allows in its own description.

export function realmKind(r) {
    if (!r) return null;
    if (r.kind) return r.kind;
    if (r.builtin === 'no_access') return r.builtin;
    if (r.is_default || r.isDefault) return 'full_access';
    return null;
}

// One line on what someone on the realm can do, said of them (the invite,
// change-realm and demote dialogs). A realm an admin made says what its own
// description says.
export function realmMeaning(r, groupName = 'the group') {
    switch (realmKind(r)) {
    case 'no_access': return `Sees none of ${groupName}’s data. They are in the group and can see who else is.`;
    case 'full_access': return 'Reads, writes and runs plugins. Admins are always on it.';
    default: return r?.description || `Does what ${r?.name || 'this realm'} allows.`;
    }
}

// The same, said to the person it is about (the consent page).
export function realmLinesForYou(r, groupName = 'the group') {
    switch (realmKind(r)) {
    case 'no_access': return [`See none of ${groupName}’s data. You are in it, and can see who else is`];
    case 'full_access': return [`Read, write and use its plugins’ tools in ${groupName}’s graph`];
    default: return [r?.description || `Do what ${r?.name || 'its realm'} allows in ${groupName}’s graph`];
    }
}

// What the realm allows, in a word or three (a contract row's note).
export function realmShort(r) {
    switch (realmKind(r)) {
    case 'no_access': return 'sees none of its data';
    case 'full_access': return 'read, write and use its plugins’ tools';
    default: return null;
    }
}
